import { render, staticRenderFns } from "./CreateWalletNew.vue?vue&type=template&id=5e12a49f&"
import script from "./CreateWalletNew.vue?vue&type=script&lang=ts&"
export * from "./CreateWalletNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports